"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductSpecsRow;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _productSpecsItem = _interopRequireDefault(require("./product-specs-item.js"));
/**
 * Local Imports
 */

const RowGroupContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RowGroupContainer",
  class: "pl-rq7gbap"
});
const RowHeadingContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RowHeadingContainer",
  class: "pl-r8wdx0p"
});

/**
 * Row Component.
 *
 * @param {Object} props React props
 * @param {String} props.rowHeading Row Header
 * @param {Array} props.items Array of rows (supports both rendered React components and plain objects)
 * @param {String} props.layout String Layouts
 * @param {Object} props.imageProps Full Image Props
 * @param {Object} props.tableProps Features Table Props
 * @param {Object} props.multiColumnProps MultiColumn layout Props
 * @returns {React.ReactElement} Row Component
 * @public
 */

function ProductSpecsRow({
  rowHeading,
  items,
  layout
}) {
  return /*#__PURE__*/_react.default.createElement(RowGroupContainer, {
    "data-cy": "row"
  }, /*#__PURE__*/_react.default.createElement(RowHeadingContainer, {
    "data-cy": "row-header"
  }, rowHeading && /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: rowHeading,
    headlineSize: "h5",
    headlineTag: "h3",
    textAlign: "start"
  })), items?.map((item, i) => {
    return /*#__PURE__*/_react.default.isValidElement(item) ? item : /*#__PURE__*/_react.default.createElement(_productSpecsItem.default, (0, _extends2.default)({
      key: i,
      layout: layout
    }, item));
  }));
}
ProductSpecsRow.propTypes = {
  layout: _propTypes.default.oneOf(['features', 'fullImage', 'multiColumn']),
  items: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]),
  rowHeading: _propTypes.default.string,
  imageProps: _propTypes.default.object,
  tableProps: _propTypes.default.object,
  multiColumnProps: _propTypes.default.object
};